import React from 'react';
import PropTypes from 'prop-types';
import { useVisualisationsConfig } from '~SpectateStore/hooks/clientStateHooks';
import { useSportradarWidget } from '~shared/hooks/useSportradarWidget';
import './styles/sportradar.scss';
import './styles/customSportradar.scss';

const SportRadarVisualization = ({ eventId, updateStatusCallback }) => {
    const { enabled } = useVisualisationsConfig();
    const { widgetWrapperRef, widgetName } = useSportradarWidget(
        eventId,
        ({ error, matchStatus }) => updateStatusCallback(Boolean(error) || typeof matchStatus !== 'string')
    );

    if (!enabled || !eventId) {
        updateStatusCallback(true);

        return null;
    }

    return (
        <div ref={widgetWrapperRef}>
            <div id={widgetName} className={widgetName}></div>
        </div>
    );
};

SportRadarVisualization.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    updateStatusCallback: PropTypes.func,
};

export default SportRadarVisualization;
